import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from "@mzc-pdc/ui";
import { useTranslation } from "react-i18next";

const DialogDelete = ({ items, title, contents, actionButtonTitle, actionPending, onClickSubmit, onClickClose }) => {
    const { t } = useTranslation();

    return (
        <Dialog variant={"basic"} open>
            <DialogTitle>
                {title ? title : t(`common::label::Delete ${items.length > 1 ? "items" : "the item"}?`)}
            </DialogTitle>
            {/* DAM-658: v2(dialog-delete-v2)와 같은 방식으로 맞춘다 — 스크롤이 없는 확인 다이얼로그라
                gutter 를 예약하지 않는다(패딩 보정이 아니라 예약 자체를 끄는 쪽) */}
            <DialogContent children={contents} sx={{ "&&": { scrollbarGutter: "auto" } }} />
            <DialogActions>
                <Button variant={"text"} color={`grey`} onClick={() => onClickClose()}>
                    {t("common::label::Cancel")}
                </Button>
                <Button
                    variant={`contained`}
                    disabled={actionPending}
                    loading={actionPending}
                    onClick={(e) => {
                        e.stopPropagation();
                        onClickSubmit();
                    }}
                    color={`error`}
                >
                    {t(`common::label::${actionButtonTitle ?? "Delete"}`, `${actionButtonTitle ?? "Delete"}`)}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default DialogDelete;
